export const NON_LOCALIZED_PREFIXES = ['/admin', '/downloads', '/api'];

export function isNonLocalizedPath(pathname: string) {
  return NON_LOCALIZED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}
